import PropTypes from 'prop-types';
import * as React from 'react';
import { DEPRECATED_PROP_MESSAGES } from '../../constants/messages.js';
import { useId } from '../../hooks/use-id.js';
import { createComponent } from '../core/create-component.js';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { useNonNullishFormFieldContext } from './form.context.js';
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpreadProps(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
const propTypes = {
  sizeVariant: deprecatedProp(PropTypes.oneOf(['standard', 'mega']), DEPRECATED_PROP_MESSAGES.size),
  size: PropTypes.oneOf(['standard', 'mega'])
};
const FormError = createComponent({
  displayName: 'FormError',
  root: 'p',
  propTypes,
  propConfig: {
    classNames(props) {
      const classes = new Set(['swan-input-group-error-text']);
      if (props.sizeVariant === 'mega' || props.size === 'mega') classes.add('swan-input-group-error-text-mega');
      return classes;
    },
    processProps(props) {
      const id = useId(props.id);
      const {
        setErrorIds
      } = useNonNullishFormFieldContext();
      // add the id to the collection on load, and remove on unmount
      React.useEffect(() => {
        if (id) {
          setErrorIds(s => new Set([...s, id]));
        }
        return () => {
          if (id) {
            setErrorIds(s => {
              const newSet = new Set([...s]);
              newSet.delete(id);
              return newSet;
            });
          }
        };
      }, [id, setErrorIds]);
      return _objectSpreadProps(_objectSpread({}, props), {
        id
      });
    }
  }
});
FormError.defaultProps = {
  size: 'standard'
};
export { FormError };